if (!customElements.get('amaca-product-title')) {
  customElements.define('amaca-product-title', class extends HTMLElement {
    connectedCallback() {
      this.heading = this.closest('h1');
      this.label = this.querySelector('span');
      if (!this.heading || !this.label) return;
      this.desktop = matchMedia('(min-width: 990px)');
      this.schedule = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.fit());
      };
      this.observer = new ResizeObserver(entries => {
        const width = entries[0].contentRect.width;
        if (width !== this.width) { this.width = width; this.schedule(); }
      });
      this.observer.observe(this.heading.parentElement);
      this.desktop.addEventListener('change', this.schedule);
      window.addEventListener('resize', this.schedule);
      document.fonts.addEventListener('loadingdone', this.schedule);
      document.fonts.ready.then(() => { if (this.isConnected) this.schedule(); });
      this.schedule();
    }
    fit() {
      this.heading.style.removeProperty('font-size');
      if (!this.desktop.matches) return;
      const available = this.getBoundingClientRect().width;
      if (!available) return;
      let high = parseFloat(getComputedStyle(this.heading).fontSize);
      if (this.label.getBoundingClientRect().width <= available) return;
      let low = 1;
      for (let step = 0; step < 12; step++) {
        const size = (low + high) / 2;
        this.heading.style.setProperty('font-size', `${size}px`, 'important');
        if (this.label.getBoundingClientRect().width > available - 1) high = size;
        else low = size;
      }
      this.heading.style.setProperty('font-size', `${low}px`, 'important');
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      this.desktop?.removeEventListener('change', this.schedule);
      window.removeEventListener('resize', this.schedule);
      document.fonts.removeEventListener('loadingdone', this.schedule);
    }
  });
}
